import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  position: relative;
  /* z-index: ; */

  height: calc(293px - 2rem);

  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    display: block;
    width: 100%;
    height: 293px;

    path {
      transition: fill 0.2s ease-in-out;
    }

    .pattern-bottom {
      fill: ${props => props.theme.color.mediumBg};
    }
    .pattern-top {
      fill: ${props => props.theme.color.lightBg};
    }
    .pattern-middle {
      fill: ${props => props.theme.color.darkBg};
    }
  }
`

export default function Transition(props) {
  const { reverse, transitionId } = props
  const milkshakePatternId = `milkshake-pattern-${transitionId}`

  const patternTopClass = reverse ? "pattern-bottom" : "pattern-top"
  const patternBottomClass = reverse ? "pattern-top" : "pattern-bottom"

  return (
    <Wrapper>
      <svg version="1.1" xmlns="http://www.w3.org/2000/svg">
        <pattern
          id={milkshakePatternId}
          width="681"
          height="293"
          patternUnits="userSpaceOnUse"
          viewBox="0 0 681 293"
        >
          <path
            className={patternTopClass}
            d="m-5.6843e-14 175v-175h681v175c-22.986-27.333-39.685-41-50.098-41-15.155 0-26.421 17.631-36.147 34.631-11.412 19.947-13.339 39.737-21.438 39.737-7.4381 0-12.062-21.302-21.686-39.737-9.7862-18.746-24.605-34.631-36.07-34.631-15.52 0-24.656 24.343-36.02 52.021-12.716 30.972-19.57 65.651-27.245 65.651-15.029 0-15.029-30.906-25.413-52.687-11.982-25.135-21.901-44.263-33.913-44.263s-19.679 12.71-28.36 27.177c-7.2932 12.154-12.078 26.47-24.111 26.47-12.318 0-29.906-44.238-48.876-82.747-12.97-26.329-25.375-51.671-41.977-51.671-17.253 0-26.181 23.998-36.643 51.671-14.33 37.901-28.755 82.747-45.918 82.747-21.07 0-28.171-57.963-44.916-108.57-12.268-37.078-21.309-71.079-37.858-71.079-19.258 0-30.366 33.623-42.026 65.988-12.037 33.411-24.585 65.818-42.286 80.295z"
            fill="#FF7D00"
          />
          <path
            className={patternBottomClass}
            d="m-5.6843e-14 175v118h681v-118c-22.986-27.333-39.685-41-50.098-41-15.155 0-26.421 17.631-36.147 34.631-11.412 19.947-13.339 39.737-21.438 39.737-7.4381 0-12.062-21.302-21.686-39.737-9.7862-18.746-24.605-34.631-36.07-34.631-15.52 0-24.656 24.343-36.02 52.021-12.716 30.972-19.57 65.651-27.245 65.651-15.029 0-15.029-30.906-25.413-52.687-11.982-25.135-21.901-44.263-33.913-44.263s-19.679 12.71-28.36 27.177c-7.2932 12.154-12.078 26.47-24.111 26.47-12.318 0-29.906-44.238-48.876-82.747-12.97-26.329-25.375-51.671-41.977-51.671-17.253 0-26.181 23.998-36.643 51.671-14.33 37.901-28.755 82.747-45.918 82.747-21.07 0-28.171-57.963-44.916-108.57-12.268-37.078-21.309-71.079-37.858-71.079-19.258 0-30.366 33.623-42.026 65.988-12.037 33.411-24.585 65.818-42.286 80.295z"
            fill="#9013FE"
          />
          <path
            className="pattern-middle"
            d="m671.09 129.74c-4.3491-4.0524-10.457-13.149-14.629-19.387-5.3941-8.0594-11.353-14.949-19.847-18.09-19.068-7.0514-36.204 9.6409-42.706 27.3-5.1941 14.11-13.583 54.318-22.518 54.344-9.8442 0.024933-17.603-50.843-25.992-65.782-10.459-18.635-30.111-29.134-46.021-12.771-21.115 21.712-26.772 115.52-47.647 116.23-25.82 0.88336-18.408-106.01-65.479-100.23-13.578 1.667-16.967 52.329-45.843 52.329-30.02 0-43.578-62.106-48.891-78.299-3.3741-10.282-6.7601-20.961-12.538-29.733-5.9691-9.0687-13.29-20.33-27.91-21.61-17.261-1.5091-30.77 26.507-36.275 38.957-11.347 25.674-22.2 101.55-48.19 100.91-25.648-0.63046-43.417-111.17-48.689-127.08-5.7891-17.472-12.087-36.472-27.502-44.157-0.49901-0.24933-0.97902-0.52123-1.496-0.74563-18.471-8.0036-30.274 10.394-36.473 27.883-7.8012 22-13.261 45.197-22.551 66.435-4.9201 11.245-11.285 20.588-18.602 29.743-0.96816 1.2109-6.322 8.0111-11.289 8.0111v84c5.7653 0 12.363-6.7956 16.131-11.8 7.0239-9.3294 10.828-18.755 15.776-30.156 9.3452-21.537 17.025-44.142 22.681-67.364 3.0401-12.482 10.881-59.916 29.705-58.943 2.132 0.10923 4.1681 0.94985 6.1181 2.3164 16.513 11.569 26.55 63.306 30.028 73.884 5.3011 16.13 23.171 128.21 48.969 128.85 26.141 0.64827 37.055-76.282 48.466-102.31 5.5351-12.625 19.12-41.033 36.487-39.503 14.7 1.2954 22.064 12.716 28.071 21.912 5.8091 8.8953 9.2122 19.722 12.607 30.148 5.0481 15.505 8.8432 31.383 15.41 46.172 3.8791 8.7374 8.5472 17.336 14.834 23.92 9.4482 9.8938 22.877 13.688 31.3 0.16978 3.2011-5.1375 5.0921-11.224 7.5032-16.936 2.8811-6.8175 6.5571-13.187 11.073-18.613 4.5971-5.5269 9.8492-8.9784 16.516-8.5581 3.9891 0.25171 7.9042 1.4723 11.434 3.7056 10.723 6.7831 16.552 21.031 20.764 33.893 4.6571 14.217 7.5912 29.127 12.211 43.35 2.6821 8.2506 7.1051 21.171 16.158 20.86 20.996-0.72663 26.684-95.838 47.922-117.86 16-16.589 35.767-5.9437 46.288 12.952 8.4332 15.148 16.238 66.724 26.137 66.696 8.9932-0.022559 17.429-40.794 22.648-55.098 6.5451-17.907 23.775-34.833 42.956-27.682 8.5422 3.1832 14.735 9.6184 20.162 17.788 4.1991 6.3272 6.9445 11.181 10.497 16.406 1.1717 1.7236 7.8958 11.8 12.147 11.8v-84c-3.5612 0-6.8652-1.4195-9.912-4.2584z"
            fill="#A4D2EB"
          />
        </pattern>

        <rect
          x="0"
          y="0"
          width="100%"
          height="293"
          fill={`url(#${milkshakePatternId})`}
        />
      </svg>
    </Wrapper>
  )
}
